<template lang="html">
  <v-text-field
    :label="label"
    :prepend-inner-icon="icon"
    :value="value"
    @input="$emit('input', $event)"
    ref="date"
    class="busie-date-input"/>
</template>

<script>
import flatpickr from 'flatpickr'

export default {
  props: {
    value: {
      type: String
    },
    minDate: {
      type: String,
      required: false,
    },
    range: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    _fp: {}
  }),
  computed: {
    label () {
      return this.range ? 'Select a range of dates ..' : 'Select a date ..'
    },
    icon () {
      return this.range ? 'mdi-calendar-multiple' : 'mdi-calendar'
    },
    config: vm => ({
      minDate: vm.minDate,
      mode: vm.range ? 'range' : 'single',
      dateFormat: 'Y/n/j'
    })
  },
  mounted () {
    let el;
    if (this.$refs.date) {
      el = this.$refs.date.$el.getElementsByTagName('input')[0]
    } else {
      el = document.getElementsByClassName('busie-date-input')
    }
    this._fp = flatpickr(el, this.config)
  },
  watch: {
    range (val) {
      this._fp.set('mode', val ? 'range' : 'single')
    }
  },
}
</script>

<style lang="css" scoped>
</style>
